import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-kickstarter',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Kickstarter icon</title><path d="M7.168 0c-3.2 0-5.797 2.579-5.797 5.758v12.484C1.371 21.42 3.968 24 7.168 24c1.981 0 3.716-.978 4.768-2.479l.794.79c2.26 2.245 5.943 2.245 8.203 0a5.724 5.724 0 001.696-4.075 5.724 5.724 0 00-1.696-4.074l-2.182-2.168 2.182-2.156a5.724 5.724 0 001.696-4.074 5.724 5.724 0 00-1.696-4.074c-2.26-2.246-5.942-2.246-8.203 0l-.794.789A5.797 5.797 0 007.168 0Z"/></svg>`,
    styles: []
})
export class SimpleIconsKickstarterComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#05CE78';
    @Input() className: string = 'simple-icons-kickstarter'
    constructor() {}
    ngOnInit(): void {}
}
